// extracted by mini-css-extract-plugin
export var carousel = "style-module--carousel--c17f3";
export var imageWrapper = "style-module--image-wrapper--e931c";
export var mediaGridSection = "style-module--media-grid-section--e2103";